// Usage tracking: records when a logged-in user opens/returns to the app, plus a
// light heartbeat every few minutes while it's visible (so we can derive "time
// spent"). Fire-and-forget; 401s (logged out) are ignored. See User Management.
const API = process.env.REACT_APP_API_URL || '';
const HEARTBEAT_MS = 3 * 60 * 1000;

let started = false;
let timer = null;

function ping() {
  fetch(`${API}/api/activity`, { method: 'POST', credentials: 'include' }).catch(() => {});
}

// Idempotent: every call records an open now; the first call also wires the
// foreground listener + heartbeat interval.
export function startActivityTracking() {
  ping();
  if (started) return;
  started = true;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') ping();
  });
  timer = setInterval(() => {
    if (document.visibilityState === 'visible') ping();
  }, HEARTBEAT_MS);
}
